import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kp-mobile-promo',
  templateUrl: './mobile-promo.component.html',
  styleUrls: ['./mobile-promo.component.scss'],
})
export class MobilePromoComponent implements OnInit {
  @Input() isFullScreen: boolean;
  @Output() closeClicked = new EventEmitter();

  ngOnInit() {
    if (this.isFullScreen === undefined) {
      this.isFullScreen = false;
    }
  }
}
